(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCrewBatchers.factory:CrewBatchFactory
     *
     * @description
     *
     */
    angular
        .module('airport')
        .factory('AirportFactory', AirportFactory);

    function AirportFactory() {

        function SearchCriteriaDTO() {
        	this.airportCode = null;
        	this.airportName = null;
        	this.fuelSupplier = null;
          this.countryCode = null;
        	this.layover = null;
        	this.base = null;
        	this.pageSize = null;
        	this.startPosition = null;
        }

		function FuelSupplierDTO() {
			this.companyName = null;
			this.city = null;
			this.fuelSupplierId = null;
		}

		function AirportDTO(){
			this.airPortCode = null;
			this.airPortName = null;
		}

		function AirportInfoDTO(){
			this.airportCode = null;
			this.airportName = null;
			this.icaoCode = null;
			this.fromBaseBaggageWeight = null;
			this.toBaseBaggageWeight = null;
			this.layoverRate = null;
			this.airportEmail = null;
			this.layOver = null;
			this.base = null;
			this.euAirport = null;
			this.engineerRequirement = null;
			this.seniorPilotRequired = null;
      this.seniorPilotRequiredStartDate = null;
      this.seniorPilotRequiredEndDate = null;
      this.seniorPilotRequiredFlyingHrs = null;
			this.seniorFoRequired = null;
      this.seniorFoRequiredStartDate = null;
      this.seniorFoRequiredEndDate = null;
      this.seniorFoRequiredFlyingHrs = null;
      this.seniorSoRequired = null;
      this.seniorSoRequiredStartDate = null;
      this.seniorSoRequiredEndDate = null;
      this.seniorSoRequiredFlyingHrs = null;
			this.gmtOffSetAction = null;
			this.gmtOffSetHours = null;
			this.airportCategory = null;
			this.version = -1;
			this.airportLangReqList = null;
			this.countryCode = null;
			this.domestic = null;
			this.rotEmailRequired = null;
			this.minGroundTimeInMin = null;
			this.airportRotationEmail = null;
			this.onlyMaleCockPitCrewAllowed=null;
			this.onlyMaleCockPitCrewValidationStartDate=null;
			this.onlyMaleCockPitCrewValidationEndDate=null;
			this.onlyFemaleCockPitCrewAllowed=null;
			this.onlyFemaleCockPitCrewValidationStartDate=null;
			this.onlyFemaleCockPitCrewValidationEndDate=null;
      this.blockGdEmail=null;
      this.cmcValRequired=null;
      this.recencyUpdateRequired=null;
      this.recencyAlertOffsetHours=null;

		}

		function AirportCategoryDTO(){
			this.code = null;
			this.desc = null;
			this.status = null;
		}

		function LanguageReqInfoDTO(){
			this.languageCode = null;
			this.languageDesc = null;
			this.languageReqId = null;
			this.noOfCrew = 0;
			this.minReqCrew = 0;
			this.version = -1;
		}

		function DeleteAirportRequest(){
			this.airportCode = null;
			this.version = null;
		}

		function CountryDTO(){
			this.code = null;
			this.description = null;
		}

		function FormatAirportSupplierList(supplierList){
			var formattedList = [];
	        angular.forEach(supplierList, function (supplier) {
	        	var apSupplier = new FuelSupplierDTO();
	        	apSupplier.companyName = supplier.companyName;
	        	apSupplier.city = supplier.city;
	        	apSupplier.fuelSupplierId = supplier.fuelSupplierId;
	            formattedList.push(apSupplier);
	        });
	        return formattedList;
		}


		function FormatAirportList(airportList){
			var formattedList = [];
	        angular.forEach(airportList, function (ap) {
	        	var airport = new AirportDTO();
	        	airport.airPortCode = ap.airPortCode;
	        	airport.airPortName = ap.airPortName;
	            formattedList.push(airport);
	        });
	        return formattedList;
		}

		function PopulateAirportSearchRequest(params){
			var searchRequest = new SearchCriteriaDTO();
			searchRequest.airportCode = params.airportCode != null ? params.airportCode.airPortCode : null;
			searchRequest.airportName = params.airportName;
			searchRequest.fuelSupplier = params.fuelSupplier != null ? params.fuelSupplier.city != null ? params.fuelSupplier.city
					: params.fuelSupplier
					: null;
      searchRequest.countryCode =  params.countryCode != null ? params.countryCode.code : null;
			searchRequest.layover = params.layover;
			searchRequest.base = params.base;
			searchRequest.pageSize = params.pageSize;
			searchRequest.startPosition = params.startPosition
			return searchRequest;
		}

		function FormatAirportInfoSearchResponse(dataList) {
			var airportInfo = [];
			angular.forEach(dataList, function(ap) {
				var airport = new AirportInfoDTO();
				airport.airportCode = ap.airportCode;
				airport.airportName = ap.airportName;
				airport.icaoCode = ap.icaoCode;
				airport.fromBaseBaggageWeight = ap.fromBaseBaggageWeight;
				airport.toBaseBaggageWeight = ap.toBaseBaggageWeight;
				airport.layoverRate = ap.layoverRate;
				airport.airportEmail = ap.airportEmail;
				airport.layOver = ap.layOver;
				airport.base = ap.base;
				airport.euAirport = ap.euAirport;
				airport.engineerRequirement = ap.engineerRequirement;
				airport.seniorPilotRequired = ap.seniorPilotRequired;
        airport.seniorPilotRequiredStartDate = convertDateDDMMYYYY(ap.seniorCrewConfigAdaptDTO.seniorPilotEffectiveStartDate);
        airport.seniorPilotRequiredEndDate = convertDateDDMMYYYY(ap.seniorCrewConfigAdaptDTO.seniorPilotEffectiveEndDate);
        airport.seniorPilotRequiredFlyingHrs = ap.seniorCrewConfigAdaptDTO.seniorPilotReqFlyMins;
				airport.seniorFoRequired = ap.seniorFoRequired;
        airport.seniorFoRequiredStartDate = convertDateDDMMYYYY(ap.seniorCrewConfigAdaptDTO.seniorFoEffectiveStartDate);
        airport.seniorFoRequiredEndDate = convertDateDDMMYYYY(ap.seniorCrewConfigAdaptDTO.seniorFoEffectiveEndDate);
        airport.seniorFoRequiredFlyingHrs = ap.seniorCrewConfigAdaptDTO.seniorFoReqFlyMins;
        airport.seniorSoRequired = ap.seniorSoRequired;
        airport.seniorSoRequiredStartDate = convertDateDDMMYYYY(ap.seniorCrewConfigAdaptDTO.seniorSoEffectiveStartDate);
        airport.seniorSoRequiredEndDate = convertDateDDMMYYYY(ap.seniorCrewConfigAdaptDTO.seniorSoEffectiveEndDate);
        airport.seniorSoRequiredFlyingHrs = ap.seniorCrewConfigAdaptDTO.seniorSoReqFlyMins;
				airport.rotEmailRequired = ap.rotEmailRequired;
				airport.gmtOffSetAction = ap.gmtOffsetAction;
				airport.gmtOffSetHours = ap.gmtOffsetAction + ap.gmtOffsetHours;
				airport.airportCategory = ap.airportCategory;
				airport.version = ap.version;
				airport.airportLangReqList = ap.airportLanguageReq;
				airport.domestic = ap.domestic ? "Yes" : "No";
				airport.minGroundTimeInMin = ap.minGroundTimeInMin;
				airport.airportRotationEmail = ap.airportRotEmail;
        airport.blockGdEmail = ap.blockGdEmail;
        airport.cmcValRequired = ap.cmcValRequired;
        airport.recencyUpdateRequired = ap.recencyUpdateRequired;
        airport.recencyAlertOffsetHours = ap.recencyAlertOffsetHours;

				if(ap.airportCockpitCrewRestrictionDTO.isOnlyMaleAllowed){
          airport.onlyMaleCockPitCrewAllowed=ap.airportCockpitCrewRestrictionDTO.isOnlyMaleAllowed;
          airport.onlyMaleCockPitCrewValidationStartDate=ap.airportCockpitCrewRestrictionDTO.fromDate;
          airport.onlyMaleCockPitCrewValidationEndDate=ap.airportCockpitCrewRestrictionDTO.toDate;
        }else{
          airport.onlyFemaleCockPitCrewAllowed=ap.airportCockpitCrewRestrictionDTO.isOnlyFemaleAllowed;
          airport.onlyFemaleCockPitCrewValidationStartDate=ap.airportCockpitCrewRestrictionDTO.fromDate;
          airport.onlyFemaleCockPitCrewValidationEndDate=ap.airportCockpitCrewRestrictionDTO.toDate;
        }







				var country = new CountryDTO();
				country.code = ap.countryCode;
				country.description = ap.countryName;

				airport.countryCode = country;
				airportInfo.push(airport);
			});
			return airportInfo;
		}

		function FormatAirportCategorySearchResponse(airportCatList){
			var formatedAirportCats = [];
			angular.forEach(airportCatList, function(cat) {
				var apcat = new AirportCategoryDTO();
				apcat.code = cat.code;
				apcat.desc = cat.desc;
				apcat.status = cat.status;
				formatedAirportCats.push(apcat);
			});
			return formatedAirportCats;
		}

		function FormatLanguagesSearchResponse(languagesList){
			var formated = [];
			angular.forEach(languagesList, function(lang) {
				var language = new LanguageReqInfoDTO();
				language.languageCode = lang.languageCode;
				language.languageDesc = lang.languageDesc;
				formated.push(language);
			});
			return formated;
		}

		function GetNewAirport(){
			var airportInfo = new AirportInfoDTO();
			airportInfo.layOver = true;
			airportInfo.base = true;
			airportInfo.domestic = true;
			airportInfo.euAirport = false;
			airportInfo.engineerRequirement = false;
			airportInfo.seniorPilotRequired = false;
			airportInfo.seniorFoRequired = false;
      airportInfo.seniorSoRequired = false;
			airportInfo.rotEmailRequired = false;
			airportInfo.recencyUpdateRequired = false;
			airportInfo.gmtOffSetAction = {sign:"+"};
			return airportInfo;
		}

		function FormatGridSelectedRow(rowData){
			var airportInfo = new AirportInfoDTO();
			airportInfo.airportCode = rowData.airportCode;
			airportInfo.airportName = rowData.airportName;
			airportInfo.icaoCode = rowData.icaoCode;
			airportInfo.fromBaseBaggageWeight = rowData.fromBaseBaggageWeight;
			airportInfo.toBaseBaggageWeight = rowData.toBaseBaggageWeight;
			airportInfo.layoverRate = rowData.layoverRate;
			airportInfo.airportEmail = rowData.airportEmail;
			airportInfo.airportRotationEmail = rowData.airportRotationEmail;
      airportInfo.blockGdEmail = rowData.blockGdEmail;
			airportInfo.layOver = rowData.layOver == "N" ? true : false;
			airportInfo.base = rowData.base == "N" ? true : false;
			airportInfo.euAirport = rowData.euAirport == "N" ? false : true;
			airportInfo.engineerRequirement = rowData.engineerRequirement == "N" ? false : true;
			airportInfo.seniorPilotRequired = rowData.seniorPilotRequired == "N" ? false : true;
      airportInfo.seniorPilotRequiredStartDate = rowData.seniorPilotRequiredStartDate;
      airportInfo.seniorPilotRequiredEndDate = rowData.seniorPilotRequiredEndDate;
      airportInfo.seniorPilotRequiredFlyingHrs = rowData.seniorPilotRequiredFlyingHrs;
			airportInfo.seniorFoRequired = rowData.seniorFoRequired == "N" ? false : true;
      airportInfo.seniorFoRequiredStartDate = rowData.seniorFoRequiredStartDate;
      airportInfo.seniorFoRequiredEndDate = rowData.seniorFoRequiredEndDate;
      airportInfo.seniorFoRequiredFlyingHrs = rowData.seniorFoRequiredFlyingHrs;
      airportInfo.seniorSoRequired = rowData.seniorSoRequired == "N" ? false : true;
      airportInfo.seniorSoRequiredStartDate = rowData.seniorSoRequiredStartDate;
      airportInfo.seniorSoRequiredEndDate = rowData.seniorSoRequiredEndDate;
      airportInfo.seniorSoRequiredFlyingHrs = rowData.seniorSoRequiredFlyingHrs;
			airportInfo.rotEmailRequired = rowData.rotEmailRequired == "N" ? false : true;
			airportInfo.version = rowData.version;
      airportInfo.cmcValRequired = rowData.cmcValRequired == "N" ? false :true;
      airportInfo.recencyUpdateRequired = rowData.recencyUpdateRequired === "N" ? false :true;
      airportInfo.recencyAlertOffsetHours = rowData.recencyAlertOffsetHours;

      if(rowData.onlyMaleCockPitCrewAllowed){
        airportInfo.onlyMaleCockPitCrewAllowed=rowData.onlyMaleCockPitCrewAllowed;
        airportInfo.onlyMaleCockPitCrewValidationStartDate=rowData.onlyMaleCockPitCrewValidationStartDate;
        airportInfo.onlyMaleCockPitCrewValidationEndDate=rowData.onlyMaleCockPitCrewValidationEndDate;
      }else{
        airportInfo.onlyFemaleCockPitCrewAllowed=rowData.onlyFemaleCockPitCrewAllowed;
        airportInfo.onlyFemaleCockPitCrewValidationStartDate=rowData.onlyFemaleCockPitCrewValidationStartDate;
        airportInfo.onlyFemaleCockPitCrewValidationEndDate=rowData.onlyFemaleCockPitCrewValidationEndDate;
      }


			airportInfo.domestic = rowData.domestic === "Yes" ? false : true;
			airportInfo.minGroundTimeInMin = rowData.minGroundTimeInMin;

			airportInfo.gmtOffSetAction = { sign : rowData.gmtOffSetAction};
			airportInfo.gmtOffSetHours = Math.abs(rowData.gmtOffSetHours);

			var airportCat = new AirportCategoryDTO();
			airportCat.code = rowData.airportCategory != null ? rowData.airportCategory.categoryCode : null;
			airportInfo.airportCategory = airportCat;

			var country = new CountryDTO();
			country.code =  rowData.countryCode == null ? null: rowData.countryCode.code;
			country.description = rowData.countryCode == null ? null: rowData.countryCode.description;
			airportInfo.countryCode = country;

			var langRequerment = {};
			angular.forEach(rowData.airportLangReqList, function(lang) {
				if(!!lang.minReqCrew){
					langRequerment[lang.language.languageCode] = lang.minReqCrew;
				}else if(!!lang.noOfCrew){
					langRequerment[lang.language.languageCode] = lang.noOfCrew;
				}

			});

			airportInfo.airportLangReqList = langRequerment;

			return airportInfo;
		}

		function PopulateAirportDeleteRequest(params){
			var deleteRequest = new DeleteAirportRequest();
			deleteRequest.version = params.version;
			deleteRequest.airportCode = params.airportCode;
			return deleteRequest;
		}

		function PopulateAirportSaveRequest(params,langRequermentData){
			var saveRequest = new AirportInfoDTO();

			saveRequest.airportCode = params.airportCode;
			saveRequest.airportName = params.airportName;
			saveRequest.icaoCode = params.icaoCode;
			saveRequest.fromBaseBaggageWeight = params.fromBaseBaggageWeight;
			saveRequest.toBaseBaggageWeight = params.toBaseBaggageWeight;
			saveRequest.layoverRate = params.layoverRate;
			saveRequest.airportEmail = params.airportEmail;
			saveRequest.layOver = !params.layOver;
			saveRequest.base = !params.base;
			saveRequest.euAirport = params.euAirport;
			saveRequest.engineerRequirement = params.engineerRequirement;
			saveRequest.seniorPilotRequired = params.seniorPilotRequired;
      saveRequest.seniorPilotRequiredStartDate = convertDateYYYYMMDD(params.seniorPilotRequiredStartDate);
      saveRequest.seniorPilotRequiredEndDate = convertDateYYYYMMDD(params.seniorPilotRequiredEndDate);
      saveRequest.seniorPilotRequiredFlyingHrs = params.seniorPilotRequiredFlyingHrs;
			saveRequest.seniorFoRequired = params.seniorFoRequired;
      saveRequest.seniorFoRequiredStartDate = convertDateYYYYMMDD(params.seniorFoRequiredStartDate);
      saveRequest.seniorFoRequiredEndDate = convertDateYYYYMMDD(params.seniorFoRequiredEndDate);
      saveRequest.seniorFoRequiredFlyingHrs = params.seniorFoRequiredFlyingHrs;
      saveRequest.seniorSoRequired = params.seniorSoRequired;
      saveRequest.seniorSoRequiredStartDate = convertDateYYYYMMDD(params.seniorSoRequiredStartDate);
      saveRequest.seniorSoRequiredEndDate = convertDateYYYYMMDD(params.seniorSoRequiredEndDate);
      saveRequest.seniorSoRequiredFlyingHrs = params.seniorSoRequiredFlyingHrs;
			saveRequest.rotEmailRequired = params.rotEmailRequired;
			saveRequest.countryCode =  params.countryCode.code;
			saveRequest.airportCategory = params.airportCategory != null ? params.airportCategory.code : null ;
			saveRequest.version = params.version;
			saveRequest.domestic = !params.domestic;

			saveRequest.gmtOffSetAction = params.gmtOffSetAction.sign;
			saveRequest.gmtOffSetHours = params.gmtOffSetHours;
			saveRequest.minGroundTimeInMin = params.minGroundTimeInMin;
			saveRequest.airportRotationEmail = params.airportRotationEmail;
      saveRequest.blockGdEmail = params.blockGdEmail;
      saveRequest.cmcValRequired = params.cmcValRequired;
      saveRequest.recencyUpdateRequired = params.recencyUpdateRequired;
      saveRequest.recencyAlertOffsetHours = params.recencyAlertOffsetHours;

			saveRequest.onlyMaleCockPitCrewAllowed=params.onlyMaleCockPitCrewAllowed;
      saveRequest.onlyMaleCockPitCrewValidationStartDate=convertDateYYYYMMDD(params.onlyMaleCockPitCrewValidationStartDate);
      saveRequest.onlyMaleCockPitCrewValidationEndDate=convertDateYYYYMMDD(params.onlyMaleCockPitCrewValidationEndDate);

      saveRequest.onlyFemaleCockPitCrewAllowed=params.onlyFemaleCockPitCrewAllowed;
      saveRequest.onlyFemaleCockPitCrewValidationStartDate=convertDateYYYYMMDD(params.onlyFemaleCockPitCrewValidationStartDate);
      saveRequest.onlyFemaleCockPitCrewValidationEndDate=convertDateYYYYMMDD(params.onlyFemaleCockPitCrewValidationEndDate);



			var langReqArray = [];
			for(var key in params.airportLangReqList ) {
				if (params.airportLangReqList.hasOwnProperty(key)) {
					var langReq = new LanguageReqInfoDTO();
					langReq.languageCode = key;
					langReq.minReqCrew = params.airportLangReqList[key];
					langReqArray.push(langReq);
				}
			};

			var newLangReqArray = setLanguageRequermentIdAndVersion(langReqArray,langRequermentData);

			saveRequest.airportLangReqList = newLangReqArray;

			return saveRequest;
		}

		function setLanguageRequermentIdAndVersion(langReqArray,initialLangReqArray){

			angular.forEach(langReqArray, function(langReqNew) {
				angular.forEach(initialLangReqArray, function(langReqOld) {
					if(langReqOld.language != null && langReqNew.languageCode === langReqOld.language.languageCode){
						langReqNew.languageReqId = langReqOld.languageReqId;
						langReqNew.version = langReqOld.version;
					}
				});

			});

			return langReqArray;

		}

        function convertDateYYYYMMDD(date) {
            if(date) {
              var dateParts = date.split("/");
              return dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
            }
        }

        function convertDateDDMMYYYY(date) {
          if(date) {
            var dateParts = date.split("-");
            return dateParts[2] + "/" + dateParts[1] + "/" + dateParts[0];
          }
        }

        return {
        	formatAirportSupplierList : FormatAirportSupplierList,
        	formatAirportList : FormatAirportList,
        	populateAirportSearchRequest : PopulateAirportSearchRequest,
        	formatAirportInfoSearchResponse : FormatAirportInfoSearchResponse,
        	formatAirportCategorySearchResponse : FormatAirportCategorySearchResponse,
        	formatLanguagesSearchResponse : FormatLanguagesSearchResponse,
        	getNewAirport : GetNewAirport,
        	formatGridSelectedRow : FormatGridSelectedRow,
        	populateAirportDeleteRequest : PopulateAirportDeleteRequest,
        	populateAirportSaveRequest : PopulateAirportSaveRequest
        }
    }
})();
